import React from 'react'
import { observer } from 'mobx-react'
// import { quickViewState } from 'src/views/components/QuickView/state'
import { productState } from 'src/views/components/BaseProductComponent/ProductState'
import { customerContainer, mysiteContainer } from 'src/models'
import {
  ApiContent,
  IS_BROWSER,
  currencyFormat,
  i18nTranslate,
  getLiveEventStatus,
  isPAC,
  isINMarket,
  enablePlpRedesign,
  isFeatureEnabled,
  showKitStrikedPdpPriceForBA,
} from 'src/utils'
import { productDeps } from 'src/deps'
import { APPConfig, convertToBoolean, getSessionStorage } from 'config/appConfig'
import { specialProductTypes } from 'src/views/components/CatalogViews'

import './styles.scss'
import { isEquinoxMysite, isEquinoxPOSite } from 'src/utils/mySiteUtils'
import { MEMBER_PRICE } from 'src/utils/constant'

@observer
class PDPUnitPrice extends React.Component {
  static contextType = ApiContent
  constructor(props, context) {
    super(props, context)
  }
  getAccountType = () => {
    if (IS_BROWSER) {
      return customerContainer.profileResponse?.accounts?.type || ''
    }
    return this?.context?.customerType
  }

  isBAorPreferred = () => {
    const accountType = this.getAccountType()
    return (
      accountType === 'Brand Affiliate' ||
      accountType === 'Brand Affiliate - Business Entity' ||
      accountType === 'Preferred Customer/Member' ||
      false
    )
  }

  getPriceWithCurrency = (priceValue = 0, dataTestId) => {
    const formattedPrice = currencyFormat({
      price: priceValue,
    })
    const defaultTestId = customerContainer?.isRegisterUser
      ? 'qa-retail-price'
      : 'qa-regular-price'
    return (
      <span
        className="v2-price-value"
        tabIndex={0}
        data-testid={dataTestId || defaultTestId}>
        {formattedPrice}
      </span>
    )
  }

  getIsToShowMemberPrice = () => {
    const unitValue = productDeps.getUnitPriceFacetsValue(
      this.props,
      this.props?.fromSubProduct
    )
    return customerContainer?.isToShowMemberPrice(unitValue?.priceFacets)
  }

  /**
   * Returns 'Member' or 'Wholesale' price facet key.
   * - Mysite/PO unregistered visitors with member price type:
   *   - India market  → 'Member'    (India has a distinct Member Price facet)
   *   - US/CA/others  → 'Wholesale' (wholesale price IS the member price outside India)
   * - Registered users: driven by product facet availability + account type.
   */
  getPriceFacetPattern = () => {
    if (!customerContainer?.isRegisterUser) {
      const isMysiteMember = isEquinoxMysite() && mysiteContainer.mysitePriceType === MEMBER_PRICE
      if (isMysiteMember) {
        return isINMarket() ? 'Member' : 'Wholesale'
      }
    }
    return this.getIsToShowMemberPrice() ? 'Member' : 'Wholesale'
  }

  getIsToDisplayMRP = () => {
    return convertToBoolean(APPConfig?.getAppConfig()?.isToDisplayMRPOnPDP)
  }
  getIsToDisplayMRPandPriceLabel = () => {
    return convertToBoolean(
      APPConfig?.getAppConfig()?.isToDisplayMRPAndPriceLabelOnPDP
    )
  }
  renderSalePriceLabel = () => {
    if (this.props?.showSubscriptionPrice) return null
    return (
      <div className="sale-title-label">
        {this.getIsToDisplayMRP() && !this.getIsToDisplayMRPandPriceLabel()
          ? ''
          : !this.checkIfOneTimePrice()
            ? i18nTranslate('pdp.subSalePrice', 'Sub Sale Price', {
                nameSpace: 'ssr-resource',
              })
            : i18nTranslate('pdp.salePrice', 'Sale Price', {
                nameSpace: 'ssr-resource',
              })}
      </div>
    )
  }
  renderWholesalePriceLabel = () => {
    const isPACRegion = isPAC()
    const priceFacetPattern = this.getPriceFacetPattern()
    let priceLabel
    if (!this.checkIfOneTimePrice()) {
      priceLabel =
        isPACRegion || priceFacetPattern === 'Member'
          ? i18nTranslate('pdp.subMemberPrice', 'Sub Member Price')
          : i18nTranslate('pdp.subWholesalePrice', 'Sub Wholesale Price')
    } else {
      priceLabel =
        isPACRegion || priceFacetPattern === 'Member'
          ? i18nTranslate('pdp.memberPrice', 'Member Price')
          : i18nTranslate('pdp.wholesalePrice', 'Wholesale Price')
    }
    priceLabel =
      this.getIsToDisplayMRP() && !this.getIsToDisplayMRPandPriceLabel()
        ? ''
        : priceLabel
    return (
      <div className="wholesale-title-label" tabIndex={0}>
        {priceLabel}
      </div>
    )
  }

  renderRetailPriceLabel = () => {
    if (this.props?.showSubscriptionPrice) return null
    return (
      <span className="retail-title-label pr-1" tabIndex={0}>
        {!this.checkIfOneTimePrice()
          ? i18nTranslate('pdp.subretailPrice', 'Subscription Retail Price', {
              nameSpace: 'ssr-resource',
            })
          : i18nTranslate('pdp.retailPrice', 'Retail Price', {
              nameSpace: 'ssr-resource',
            })}
      </span>
    )
  }

  renderPerUnitPrice = () => {
    const enablePerUnitPrice = isFeatureEnabled('PDPUnitPrice')
    if (!enablePerUnitPrice) {
      return null
    }

    const { product } = this.props
    const {
      type = 'DEFAULT',
      properties = {},
      skuProperties = {},
    } = product || {}
    const {
      unitPriceValue: bundleUnitPriceValue = 0,
      subsUnitPriceValue: bundleSubsUnitPriceValue = 0,
      unitPrice: bundleUnitPrice = '',
    } = properties || {}
    const {
      unitPriceValue: skuUnitPriceValue = 0,
      subsUnitPriceValue: skuSubsUnitPriceValue = 0,
      unitPrice: skuUnitPrice = '',
    } = skuProperties || {}
    const selectedSku = product?.selectedSku || {}
    const isOneTimePrice = this.checkIfOneTimePrice()
    let oneTimeUnitPrice = 0
    let subsUnitPrice = 0
    let displayFormat = ''

    const parseUnitPrice = unitPrice => {
      if (typeof unitPrice === 'string') {
        try {
          return JSON.parse(unitPrice)
        } catch (e) {
          console.error('Error parsing unitPrice:', e)
          return null
        }
      }
      return unitPrice
    }

    if (specialProductTypes?.includes(type?.toLowerCase())) {
      oneTimeUnitPrice = bundleUnitPriceValue
      subsUnitPrice = bundleSubsUnitPriceValue || oneTimeUnitPrice
      const unitPriceData = parseUnitPrice(bundleUnitPrice)
      displayFormat = unitPriceData?.unitOfMeasure || 'per g'
    } else {
      oneTimeUnitPrice =
        skuUnitPriceValue || selectedSku?.skuProperties?.unitPriceValue || 0
      subsUnitPrice =
        skuSubsUnitPriceValue ||
        selectedSku?.skuProperties?.subUnitPriceValue ||
        oneTimeUnitPrice ||
        0
      const unitPriceData = parseUnitPrice(
        skuUnitPrice || selectedSku?.skuProperties?.unitPrice
      )
      displayFormat = unitPriceData?.unitOfMeasure || ''
    }
    const unitPricePerGram = isOneTimePrice ? oneTimeUnitPrice : subsUnitPrice
    const formattedPrice = currencyFormat({ price: unitPricePerGram })

    if (unitPricePerGram && displayFormat) {
      return (
        <span
          className="unit-price-display ml-2"
          data-testid="qa-unit-price-display">
          <span className="unit-price-text" tabIndex={0}>
            {`(${formattedPrice}${displayFormat})`}
          </span>
        </span>
      )
    }
    return null
  }
  renderMRPLabel = () => {
    if (this.props?.showSubscriptionPrice) return null
    return (
      <span className="retail-title-label pr-1">
        {i18nTranslate('pdp.mrp', 'MRP', {
          nameSpace: 'ssr-resource',
        })}
      </span>
    )
  }

  checkIfOneTimePrice = () => {
    if (this.props?.showSubscriptionPrice) return false
    if (productState?.currentlySelectedPriceOption == 'one-time-price-button') {
      return true
    }
    return false
  }

  renderMRPPrice = unitValue => {
    const mrpPrice = unitValue?.priceFacets?.['MRP']?.['MRP']
    if (mrpPrice) {
      return currencyFormat({ price: mrpPrice })
    }
    return null
  }

  checkStrikePriceCondition = (priceAfterDiscount, priceValue) => {
    if (priceAfterDiscount === undefined) return false
    if (priceAfterDiscount >= priceValue) return null
    return priceAfterDiscount > 0 && priceAfterDiscount < priceValue
  }
  renderWholesalePriceAfterDiscount = (unitValue, dataTestId) => {
    let salePrice = 0
    const priceFacetPattern = this.getPriceFacetPattern()

    if (this.checkIfOneTimePrice()) {
      const priceFacet = unitValue?.priceFacets?.[`${priceFacetPattern} Price`]
      salePrice =
        typeof priceFacet === 'object'
          ? priceFacet?.[`${priceFacetPattern} PriceAfterDiscount`] ||
            priceFacet?.[`${priceFacetPattern} Price`]
          : priceFacet
    } else {
      const subPriceFacet =
        unitValue?.priceFacets?.[`Sub ${priceFacetPattern} Price`]
      salePrice =
        typeof subPriceFacet === 'object'
          ? subPriceFacet?.[`Sub ${priceFacetPattern} PriceAfterDiscount`] ||
            subPriceFacet?.[`Sub ${priceFacetPattern} Price`]
          : subPriceFacet
    }
    const testId = this.props.showSubscriptionPrice
      ? 'qa-subscription-discounted-price'
      : dataTestId || 'qa-wholesale-discounted-price'
    return this.getPriceWithCurrency(salePrice, testId)
  }

  renderWholesalePrice = (unitValue, dataTestId) => {
    let salePrice = 0
    const priceFacetPattern = this.getPriceFacetPattern()
    if (this.checkIfOneTimePrice()) {
      salePrice =
        unitValue?.priceFacets?.[`${priceFacetPattern} Price`]?.[
          `${priceFacetPattern} Price`
        ]
    } else {
      salePrice =
        unitValue?.priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
          `Sub ${priceFacetPattern} Price`
        ]
    }
    return this.getPriceWithCurrency(salePrice, dataTestId)
  }

  renderRetailPriceAfterDiscount = (unitValue, dataTestId) => {
    if (this.checkIfOneTimePrice()) {
      const regularPriceFacet = unitValue?.priceFacets?.['Regular Price']
      const retailPrice =
        typeof regularPriceFacet === 'object'
          ? regularPriceFacet?.['Regular PriceAfterDiscount'] ||
            regularPriceFacet?.['Regular Price']
          : regularPriceFacet

      // Check if there's an actual discount for one-time prices
      const hasDiscount =
        regularPriceFacet?.['Regular PriceAfterDiscount'] !== undefined &&
        regularPriceFacet?.['Regular PriceAfterDiscount'] <
          regularPriceFacet?.['Regular Price']

      if (!this.checkIfOneTimePrice()) {
        return this.getPriceWithCurrency(retailPrice, 'qa-sub-retail-price')
      }
      return this.getPriceWithCurrency(
        retailPrice,
        dataTestId || (hasDiscount ? 'qa-discounted-price' : 'qa-retail-price')
      )
    } else {
      const subRetailPriceFacet = unitValue?.priceFacets?.['Sub Retail Price']
      const retailPrice =
        typeof subRetailPriceFacet === 'object'
          ? subRetailPriceFacet?.['Sub Retail PriceAfterDiscount'] ||
            subRetailPriceFacet?.['Sub Retail Price']
          : subRetailPriceFacet

      // Check if there's an actual discount before using the discounted-price ID
      const hasDiscount =
        subRetailPriceFacet?.['Sub Retail PriceAfterDiscount'] !== undefined &&
        subRetailPriceFacet?.['Sub Retail PriceAfterDiscount'] <
          subRetailPriceFacet?.['Sub Retail Price']

      return this.getPriceWithCurrency(
        retailPrice,
        dataTestId || (hasDiscount ? 'qa-discounted-price' : 'qa-retail-price')
      )
    }
  }

  renderRetailPrice = (unitValue, dataTestId) => {
    const retailPrice = this.checkIfOneTimePrice()
      ? unitValue?.priceFacets?.['Regular Price']?.['Regular Price']
      : unitValue?.priceFacets?.['Sub Retail Price']?.['Sub Retail Price']

    return this.getPriceWithCurrency(
      retailPrice,
      dataTestId || 'qa-product-regular-price'
    )
  }

  renderRetailPriceForBAUsers = (unitValue = {}, dataTestId = '') => {
    const isMysiteMemberFlow =
      !customerContainer?.isRegisterUser &&
      isEquinoxMysite() &&
      mysiteContainer.mysitePriceType === 'member'

    if (isMysiteMemberFlow) {
      return this.renderRetailPrice(unitValue, dataTestId)
    }

    return this.renderRetailPriceAfterDiscount(unitValue, dataTestId)
  }

  checkAndRenderPriceV2 = unitValue => {
    if (this.props.showSubscriptionPrice) {
      let isBAorPreferred = this.isBAorPreferred()
      // On mysite with member pricing, unregistered visitors must see
      // Sub Wholesale/Member subscription pricing (not Sub Retail).
      if (!customerContainer?.isRegisterUser && isEquinoxMysite()) {
        isBAorPreferred = isBAorPreferred || mysiteContainer.mysitePriceType == 'member'
      }
      const isBundleOrKit =
        this.props?.product?.type === 'bundle' ||
        this.props?.product?.type === 'kit'
      const priceFacetPattern = this.getPriceFacetPattern()
      const regularPriceValue =
        typeof unitValue?.priceFacets?.['Regular Price'] === 'object'
          ? unitValue?.priceFacets?.['Regular Price']?.['Regular Price']
          : unitValue?.priceFacets?.['Regular Price']
      const subRetailPriceValue =
        typeof unitValue?.priceFacets?.['Sub Retail Price'] === 'object'
          ? unitValue?.priceFacets?.['Sub Retail Price']?.['Sub Retail Price']
          : unitValue?.priceFacets?.['Sub Retail Price']
      const wholesalePriceValue =
        typeof unitValue?.priceFacets?.[`${priceFacetPattern} Price`] ===
        'object'
          ? unitValue?.priceFacets?.[`${priceFacetPattern} Price`]?.[
              `${priceFacetPattern} Price`
            ]
          : unitValue?.priceFacets?.[`${priceFacetPattern} Price`]
      const subWholesalePriceValue =
        typeof unitValue?.priceFacets?.[`Sub ${priceFacetPattern} Price`] ===
        'object'
          ? unitValue?.priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
              `Sub ${priceFacetPattern} Price`
            ]
          : unitValue?.priceFacets?.[`Sub ${priceFacetPattern} Price`]

      const getStrikePrice = () => {
        if (
          (isBAorPreferred && subWholesalePriceValue >= wholesalePriceValue) ||
          (!isBAorPreferred && subRetailPriceValue >= regularPriceValue)
        ) {
          return null
        }
        if (this.props?.fromSubProduct) {
          return this.getPriceWithCurrency(
            isBAorPreferred ? wholesalePriceValue : regularPriceValue,
            'qa-subscription-original-price'
          )
        }

        const facetName = isBAorPreferred
          ? `Sub ${priceFacetPattern} Price`
          : 'Sub Retail Price'
        const priceValue = isBAorPreferred
          ? subWholesalePriceValue
          : subRetailPriceValue
        const priceFacet = unitValue?.priceFacets?.[facetName]
        const priceAfterDiscount =
          typeof priceFacet === 'object'
            ? priceFacet?.[`${facetName}AfterDiscount`]
            : undefined

        const strikePriceCheck = this.checkStrikePriceCondition(
          priceAfterDiscount,
          priceValue
        )

        if (strikePriceCheck === null) {
          return null
        }
        if (strikePriceCheck === true) {
          return this.getPriceWithCurrency(
            priceValue,
            'qa-subscription-original-price'
          )
        }
        return this.getPriceWithCurrency(
          isBAorPreferred ? wholesalePriceValue : regularPriceValue,
          'qa-subscription-original-price'
        )
      }
      const discountedPrice = isBAorPreferred
        ? this.renderWholesalePriceAfterDiscount(
            unitValue,
            'qa-subscription-discounted-price'
          )
        : this.renderRetailPriceAfterDiscount(
            unitValue,
            'qa-subscription-discounted-price'
          )

      const priceBlockClass = isBundleOrKit
        ? 'subscription-price-block bundle-kit'
        : 'subscription-price-block'

      const strikeThroughPrice = getStrikePrice()

      return (
        <div
          className={priceBlockClass}
          data-testid="qa-subscription-price-block">
          {discountedPrice}
          {strikeThroughPrice && (
            <span
              className="strike-price-value text-secondary ml-3 strikeThrough"
              data-testid="qa-subscription-original-price">
              {strikeThroughPrice}
            </span>
          )}
          {this.renderPerUnitPrice()}
        </div>
      )
    } else {
      let isBAorPreferred = this.isBAorPreferred()
      /*for mysite or product offer landing page if pricetype is set as member then we need to show wholesale price */
      if (!customerContainer?.isRegisterUser) {
        if (isEquinoxMysite() && mysiteContainer.mysitePriceType === MEMBER_PRICE) {
          isBAorPreferred = true
        }
        if (isEquinoxPOSite()) {
          const personalOfferDetails = getSessionStorage('personalOffer')
          if (personalOfferDetails?.priceType === MEMBER_PRICE) {
            isBAorPreferred = true
          }
        }
      }
      const priceFacetPattern = this.getPriceFacetPattern()
      const isBundleOrKit =
        this.props?.product?.type === 'bundle' ||
        this.props?.product?.type === 'kit'
      const wholesaleDiscount = this.checkIfOneTimePrice()
        ? unitValue?.priceFacets?.[`${priceFacetPattern} Price`]?.[
            `${priceFacetPattern} PriceDiscount`
          ]
        : unitValue?.priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
            `Sub ${priceFacetPattern} PriceDiscount`
          ]
      const retailDiscount = this.checkIfOneTimePrice()
        ? unitValue?.priceFacets?.['Regular Price']?.['Regular PriceDiscount']
        : unitValue?.priceFacets?.['Sub Retail Price']?.[
            'Sub Retail PriceDiscount'
          ]
      let bundleOnlyDiscountWholesale
      if (this.checkIfOneTimePrice()) {
        if (priceFacetPattern === 'Member') {
          bundleOnlyDiscountWholesale =
            unitValue?.priceFacets?.['Member Price']?.['Member PriceDiscount']
        } else {
          bundleOnlyDiscountWholesale =
            unitValue?.priceFacets?.['Wholesale Price']?.['bundleDiscount']
        }
      } else {
        if (priceFacetPattern === 'Member') {
          bundleOnlyDiscountWholesale =
            unitValue?.priceFacets?.['Sub Member Price']?.[
              'Sub Member PriceDiscount'
            ]
        } else {
          bundleOnlyDiscountWholesale =
            unitValue?.priceFacets?.['Sub Wholesale Price']?.['bundleDiscount']
        }
      }
      const bundleOnlyDiscountRetail = this.checkIfOneTimePrice()
        ? unitValue?.priceFacets?.['Regular Price']?.['bundleDiscount']
        : unitValue?.priceFacets?.['Sub Retail Price']?.['bundleDiscount']
      /* based on https://nuskin.atlassian.net/browse/BRW-3534
       * we are hiding retail price with label for bundle & kits
       */
      const enableBundleKitRetailPriceInNewPDP =
        APPConfig?.getAppConfig()?.enableBundleKitRetailPriceInNewPDP === 'true'

      const enableLiveEvent = convertToBoolean(getLiveEventStatus())
      const renderStrikePriceBlock = () => {
        return (
          <div className="strike-price-value text-secondary">
            {!enableLiveEvent && this.renderWholesalePriceLabel()}
            {this.renderWholesalePrice(
              unitValue,
              !this.checkIfOneTimePrice()
                ? 'qa-sub-wholesale-price'
                : 'qa-wholesale-price'
            )}
            {this.renderPerUnitPrice()}
          </div>
        )
      }

      if (isBundleOrKit) {
        if (isBAorPreferred) {
          if (
            wholesaleDiscount &&
            wholesaleDiscount > 0 &&
            bundleOnlyDiscountWholesale &&
            bundleOnlyDiscountWholesale > 0
          ) {
            /* bundle kit - BA -both sale & bundle discount */
            return (
              <div
                className="d-flex"
                priceType="bundle kit - BA -both sale & bundle discount">
                <div>
                  {this.renderSalePriceLabel()}
                  {this.renderWholesalePriceAfterDiscount(
                    unitValue,
                    !this.checkIfOneTimePrice()
                      ? 'qa-sub-sale-price'
                      : 'qa-sale-price'
                  )}
                  {enableBundleKitRetailPriceInNewPDP &&
                    !enableLiveEvent &&
                    !this.getIsToDisplayMRP() && (
                      <div className="retail-price-with-label">
                        {this.renderRetailPriceLabel()}
                        {this.renderRetailPriceForBAUsers(
                          unitValue,
                          !this.checkIfOneTimePrice()
                            ? 'qa-sub-retail-price'
                            : retailDiscount && retailDiscount > 0
                              ? 'qa-discounted-price'
                              : 'qa-retail-price'
                        )}
                      </div>
                    )}
                </div>
                <div className="pl-3">{renderStrikePriceBlock()}</div>
              </div>
            )
          } else {
            /* bundle kit - BA - only saleDiscount or no discount */
            return (
              <div
                className="d-flex"
                priceType="bundle kit - BA - only saleDiscount or no discount">
                <div>
                  <div>
                    {!enableLiveEvent && this.renderWholesalePriceLabel()}
                    {this.renderWholesalePriceAfterDiscount(
                      unitValue,
                      !this.checkIfOneTimePrice()
                        ? 'qa-sub-wholesale-price'
                        : 'qa-wholesale-price'
                    )}
                    {this.renderPerUnitPrice()}
                  </div>
                  {enableBundleKitRetailPriceInNewPDP &&
                    !enableLiveEvent &&
                    !this.getIsToDisplayMRP() && (
                      <div
                        className="retail-price-with-label"
                        data-testid={
                          !this.checkIfOneTimePrice()
                            ? 'qa-sub-retail-price'
                            : 'qa-retail-price'
                        }>
                        {this.renderRetailPriceLabel()}
                        {this.renderRetailPriceForBAUsers(
                          unitValue,
                          !this.checkIfOneTimePrice()
                            ? 'qa-sub-retail-price'
                            : retailDiscount && retailDiscount > 0
                              ? 'qa-discounted-price'
                              : 'qa-retail-price'
                        )}
                      </div>
                    )}
                </div>
                {showKitStrikedPdpPriceForBA() && wholesaleDiscount > 0 && (
                    <div className="pl-3">{renderStrikePriceBlock()}</div>
                  )}
              </div>
            )
          }
        } else {
          if (
            retailDiscount &&
            retailDiscount > 0 &&
            bundleOnlyDiscountRetail &&
            bundleOnlyDiscountRetail > 0 &&
            retailDiscount > bundleOnlyDiscountRetail
          ) {
            /* bundle kit - NON-BA - both sale & bundle discount */
            return (
              <div
                className="d-flex"
                priceType="bundle kit - NON-BA - both sale & bundle discount">
                <div>
                  <div>
                    {this.renderSalePriceLabel()}
                    {this.renderRetailPriceAfterDiscount(
                      unitValue,
                      !this.checkIfOneTimePrice()
                        ? 'qa-sub-retail-price'
                        : retailDiscount && retailDiscount > 0
                          ? 'qa-discounted-price'
                          : 'qa-retail-price'
                    )}
                    {this.renderPerUnitPrice()}
                  </div>
                  {!enableLiveEvent && !this.getIsToDisplayMRP() && (
                    <div
                      className="retail-price-with-label"
                      data-testid={
                        !this.checkIfOneTimePrice()
                          ? 'qa-sub-retail-price'
                          : 'qa-retail-price'
                      }>
                      {this.renderRetailPriceLabel()}
                      {this.renderRetailPrice(
                        unitValue,
                        !this.checkIfOneTimePrice()
                          ? 'qa-sub-retail-price'
                          : 'qa-retail-price'
                      )}
                    </div>
                  )}
                </div>
              </div>
            )
          } else {
            /* bundle kit - NON-BA - only saleDiscount or no discount */

            return (
              <div
                className={`d-flex original-price-value-no-discount ${
                  enablePlpRedesign() && customerContainer?.isRegisterUser
                    ? 'retail-no-discount-redesign'
                    : 'non-register-user-font'
                }`}
                priceType="bundle kit - NON-BA - only saleDiscount or no discount">
                <div>
                  {enablePlpRedesign() &&
                    (retailDiscount > 0 || bundleOnlyDiscountRetail > 0
                      ? this.renderSalePriceLabel()
                      : this.renderRetailPriceLabel())}
                  {this.renderRetailPriceAfterDiscount(
                    unitValue,
                    !this.checkIfOneTimePrice()
                      ? 'qa-sub-retail-price'
                      : 'qa-discounted-price'
                  )}
                  {!(retailDiscount > 0 || bundleOnlyDiscountRetail > 0) &&
                    this.renderPerUnitPrice()}
                </div>
                {(retailDiscount > 0 || bundleOnlyDiscountRetail > 0) && (
                  <div
                    className={`strike-retailprice ${
                      !customerContainer?.isRegisterUser
                        ? 'non-register-user-font'
                        : ''
                    }`}>
                    {enablePlpRedesign() && this.renderRetailPriceLabel()}
                    {this.renderRetailPrice(
                      unitValue,
                      !this.checkIfOneTimePrice()
                        ? 'qa-sub-retail-price'
                        : 'qa-retail-price'
                    )}
                    {this.renderPerUnitPrice()}
                  </div>
                )}
              </div>
            )
          }
        }
      } else {
        /* for individual products*/
        if (isBAorPreferred) {
          if (wholesaleDiscount && wholesaleDiscount > 0) {
            /* individual - BA - sale discount */
            return (
              <div
                className="d-flex"
                priceType="individual - BA - sale discount">
                <div>
                  {this.renderSalePriceLabel()}
                  {this.renderWholesalePriceAfterDiscount(
                    unitValue,
                    !this.checkIfOneTimePrice()
                      ? 'qa-sub-wholesale-price'
                      : 'qa-wholesale-price'
                  )}
                  {!enableLiveEvent && !this.getIsToDisplayMRP() && (
                    <div
                      className="retail-price-with-label"
                      data-testid={
                        !this.checkIfOneTimePrice()
                          ? 'qa-sub-retail-price'
                          : 'qa-retail-price'
                      }>
                      {this.renderRetailPriceLabel()}
                      {this.renderRetailPriceForBAUsers(
                        unitValue,
                        !this.checkIfOneTimePrice()
                          ? 'qa-sub-retail-price'
                          : retailDiscount && retailDiscount > 0
                            ? 'qa-discounted-price'
                            : 'qa-retail-price'
                      )}
                    </div>
                  )}
                </div>
                <div className="pl-3 mb-20">{renderStrikePriceBlock()}</div>
              </div>
            )
          } else {
            /* individual - BA - no discount */
            return (
              <div className="d-flex" priceType="individual - BA - no discount">
                <div>
                  <div>
                    {!enableLiveEvent && this.renderWholesalePriceLabel()}
                    {this.renderWholesalePriceAfterDiscount(
                      unitValue,
                      !this.checkIfOneTimePrice()
                        ? 'qa-sub-wholesale-price'
                        : 'qa-wholesale-price'
                    )}
                    {this.renderPerUnitPrice()}
                  </div>
                  {!enableLiveEvent && !this.getIsToDisplayMRP() && (
                    <div
                      className="retail-price-with-label"
                      data-testid={
                        !this.checkIfOneTimePrice()
                          ? 'qa-sub-retail-price'
                          : 'qa-retail-price'
                      }>
                      {this.renderRetailPriceLabel()}
                      {this.renderRetailPriceForBAUsers(
                        unitValue,
                        !this.checkIfOneTimePrice()
                          ? 'qa-sub-retail-price'
                          : retailDiscount && retailDiscount > 0
                            ? 'qa-discounted-price'
                            : 'qa-retail-price'
                      )}
                    </div>
                  )}
                </div>
              </div>
            )
          }
        } else {
          if (retailDiscount && retailDiscount > 0) {
            /* individual - NON-BA - sale discount */

            return (
              <div
                className="d-flex"
                priceType="individual - NON-BA - sale discount">
                <div>
                  <div>
                    {this.renderSalePriceLabel()}
                    {this.renderRetailPriceAfterDiscount(
                      unitValue,
                      !this.checkIfOneTimePrice()
                        ? 'qa-sub-retail-price'
                        : retailDiscount && retailDiscount > 0
                          ? 'qa-discounted-price'
                          : 'qa-retail-price'
                    )}
                    {this.renderPerUnitPrice()}
                  </div>
                  {!this.getIsToDisplayMRP() && (
                    <div
                      className="retail-price-with-label"
                      data-testid={
                        !this.checkIfOneTimePrice()
                          ? 'qa-sub-retail-price'
                          : 'qa-retail-price'
                      }>
                      {this.renderRetailPriceLabel()}
                      {this.renderRetailPrice(
                        unitValue,
                        !this.checkIfOneTimePrice()
                          ? 'qa-sub-retail-price'
                          : 'qa-retail-price'
                      )}
                    </div>
                  )}
                </div>
              </div>
            )
          } else {
            /* individual - NON-BA - no discount */
            return (
              <div
                className={`d-flex original-price-value-no-discount ${
                  enablePlpRedesign() && customerContainer?.isRegisterUser
                    ? 'retail-no-discount-redesign'
                    : ''
                }`}
                priceType="individual - NON-BA - no discount">
                <div>
                  {enablePlpRedesign() && this.renderRetailPriceLabel()}
                  <div className="price-with-unit-wrapper">
                    {this.renderRetailPriceAfterDiscount(
                      unitValue,
                      !this.checkIfOneTimePrice()
                        ? 'qa-sub-retail-price'
                        : 'qa-retail-price'
                    )}
                    {this.renderPerUnitPrice()}
                  </div>
                </div>
              </div>
            )
          }
        }
      }
    }
  }
  render() {
    const unitValue = productDeps.getUnitPriceFacetsValue(
      this.props,
      this.props?.fromSubProduct
    )

    return (
      <div className="unit-price-with-label-wrapper">
        <div className="price-with-unit-wrapper">
          {this.checkAndRenderPriceV2(unitValue)}
        </div>
        {this.getIsToDisplayMRP() && (
          <div
            className="retail-price-with-label mt-2 mb-2"
            data-testid={
              !this.checkIfOneTimePrice()
                ? 'qa-sub-retail-price'
                : 'qa-retail-price'
            }>
            {this.renderMRPLabel()}
            <span className="">{this.renderMRPPrice(unitValue) || ''}</span>
          </div>
        )}
      </div>
    )
  }
}
export { PDPUnitPrice }
export default PDPUnitPrice
